import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TotalResumeLine from 'components/Checkout2/UI/TotalResumeLine';
import { Button } from 'components/UI';
import { FunctionComponent } from 'react';

export interface FooterProps {
    buttonLabel: string;
    total: number;
    loading?: boolean;
    disableButton?: boolean;
    className?: string;
    onClickButton?: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            height: '100%',
            width: '100%'
        },
        button: {
            height: 50,
            marginTop: 18
        }
    })
);

export const Footer: FunctionComponent<FooterProps> = props => {
    const classes = useStyles(props);

    return (
        <Box className={classes.container}>
            <TotalResumeLine
                description="Total"
                value={`$${props.total.toFixed(2)}`}
            />
            <Button
                label={props.buttonLabel}
                color="black"
                size="large"
                disabled={props.disableButton}
                loading={props.loading}
                className={classes.button}
                onClick={props.onClickButton}
            />
        </Box>
    );
};

export default Footer;
